import React, { Component } from 'react'
import PropTypes from 'prop-types'

import { resultItem } from '../utils/propTypes'

import BudgetRating from './BudgetRating'
import Carousel from './Carousel'
import GridItem from './GridItem'
import { accommodationTypeMap } from '../utils/constants'

export default class ImageMultiFormGrid extends Component {
  static propTypes = {
    results: PropTypes.arrayOf(resultItem).isRequired,
    setActiveProperty: PropTypes.func.isRequired,
    toggleWishlist: PropTypes.func.isRequired,
  }
   componentWillReceiveProps(props){

   }


  openDownloadKeyInstructionsLink = (referenceNumber) => {
    let downloadUrl = '/account/booking/instructions/' + this.props.bookingIdsForBookedAccommodations[referenceNumber] + '/' + this.props.wishlistOrderAccIdsForBookedAccommodations[referenceNumber] +'/';
    window.open(downloadUrl)
  };




  render () {
    const { eventCity, results } = this.props
    let resultsArrayForGrid = [];
    // here we basically add every result twice to a new list. We do this because in the rendering logic every
    // second object will be rendered as a form. so we add a copy of every search result to the result list to
    // render the guest details form in the loop.
    results.map((item)=>{
      resultsArrayForGrid.push(item);
      resultsArrayForGrid.push(item);
    });
    return (
            <div className="delegate-info-grid-wrapper ">
                {resultsArrayForGrid.map((item,  index) => (
                    <GridItem item={item} key={index} index={index} {...this.props}/>

                ))}
            </div>
    )
    }

  }





// WEBPACK FOOTER //
// ./src/components/ImageMultiFormGrid.js